module.exports = __webpack_public_path__ + "static/media/money-location.27a34ef7.svg";